<template>
  <v-navigation-drawer
    class="navigation"
    app
    fixed
    permanent
    :mini-variant="miniVariant"
    disable-resize-watcher
    width="230"
    :class="themeColor"
    v-model="drawer"
    right="true">

    <v-list v-show="miniVariant" :class="themeColor" class="pa-0">
      <v-list-tile>
        <v-list-tile-action>
          <v-btn icon @click.stop="miniVariant = !miniVariant">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>

    <v-list :class="themeColor" class="avatar-list-item">
      <v-list-tile avatar>
        <v-list-tile-avatar @click="$router.push({name: 'Account'})" style="cursor: pointer">
          <v-tooltip right>
            <app-avatar slot="activator" :id="avatar" :size="44" />
            <span>個人檔案設定</span>
          </v-tooltip>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>{{nickname}}</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn
            icon
            @click.stop="miniVariant = !miniVariant">
            <v-icon>chevron_left</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>

    <v-list :class="themeColor" class="pt-0 flex-grow">
      <v-divider light></v-divider>
      <menu-item
        :key="m.text"
        v-for="m in visibleMenus"
        :routeName="m.routeName"
        :icon="m.icon"
        :text="m.text" />
    </v-list>

    <v-divider></v-divider>

    <v-list :class="themeColor">
      <menu-item icon="settings" text="設定" routeName="Settings"/>
      <menu-item icon="mdi-logout-variant" text="登出" @click="signout"/>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import {mapActions} from 'vuex';
import {mapState} from 'vuex';
import MenuItem from './MainMenuItem';

export default {
  components: {
    'menu-item': MenuItem
  },

  data() {
    return {
      miniVariant: true,
      drawer: false,
      menus: [
        {text: '首頁', icon: 'home', routeName: 'Home', roles: ['student', 'teacher']},
        {text: '訊息列表', icon: 'mdi-chat-processing', routeName: 'Chats', roles: ['student', 'teacher']},
        {text: '老師', icon: 'supervised_user_circle', routeName: 'Teachers', roles: ['student']},
        // {text: '題庫', icon: 'list_alt', routeName: 'Question'},
        {text: '輔導', icon: 'cast_connected', routeName: 'Fudao', roles: ['teacher']}
        // {text: 'icelink測試', icon: 'free_breakfast', routeName: 'IcelinkTest'}
      ]
    };
  },

  computed: {
    ...mapState({
      nickname: state => state.profile ? state.profile.nickname : '',
      avatar: state => state.profile ? state.profile.avatar : null
    }),

    visibleMenus() {
      return this.menus.filter(menu => {
        return this.isAllow(menu.roles);
      });
    }
  },

  methods: {
    ...mapActions(['signout']),

    toggle() {
      this.miniVariant = !this.miniVariant;
    }
  }
};
</script>

<style lang="stylus" scoped>

.navigation {
  display: flex;
  flex-direction: column;
}

.avatar-list-item {
  padding: 0.4rem 0 0.4rem 0;
}

</style>
